

import React, { SyntheticEvent, useState } from 'react';
import { Form } from '../../components/forms/Form';
import cn from 'classnames';
import _ from 'lodash';

// import { SSO_MIGRATION_MESSAGE } from '../../constants';
import styles from './agent-settings-form.module.css';
import Alert from '../../components/alert';
import { Label } from '../../components/forms/Label';
import { EmailInput } from '../../components/forms/Input';
import ButtonDefault, { ButtonPrimary } from '../../components/forms/Buttons';

type AgentSettingsFormProps = {
  email: string,
  errorMessage?: string,
  onSave: (email: string) => void,
};

export const AgentSettingsForm: React.FC<AgentSettingsFormProps> = ({
  email,
  errorMessage,
  onSave,
}) => {
  const [emailInput, updateEmailInput] = useState<string>(email);
  const [emailErrorMessage, updateEmailErrorMessage] = useState<string | undefined>();

  const hasEmailInputChanged = email !== emailInput;
  const isSaveDisabled =
    !hasEmailInputChanged ||
    !_.isEmpty(emailErrorMessage) ||
    _.isEmpty(emailInput);

  const handleFormSubmit = (_e: SyntheticEvent): void => {
    onSave(emailInput);
  };

  const handleOnCancel = (): void => {
    updateEmailInput(email);
    updateEmailErrorMessage(undefined);
  };

  return (
    <div className={cn(styles.root, 'container-fluid')}>
      <div className={cn(styles.formContainer)}>
        <Form onSubmit={handleFormSubmit}>
          {errorMessage && <Alert type="danger" message={errorMessage} />}
          {/* <div className={cn(styles.definition)}>
            <p>{SSO_MIGRATION_MESSAGE}</p>
          </div> */}
          <div className={cn(styles.inputRowWrapper)}>
            <div className={cn(styles.inputLabelWrapper)}>
              <Label htmlFor="emailId" text="Email:" />
            </div>
            <div className={cn(styles.inputFieldWrapper)}>
              
                <EmailInput
                  name="email"
                  id="emailId"
                  onChange={(e: SyntheticEvent<HTMLInputElement>): void => {
                    updateEmailInput(e.currentTarget.value);
                  }}
                  onError={(errorMessage?: string): void => {
                    updateEmailErrorMessage(errorMessage);
                  }}
                  value={emailInput}
                />
              
            </div>
          </div>

          <div className={cn(styles.linkWrapper)}>
            <a href="/password" target="_blank">
              Change your password
            </a>
          </div>

          <div className={cn(styles.buttonGroupWrapper)}>
            <div className={cn(styles.buttonWrapper)}>
              <ButtonDefault
                id="cancelButton"
                onClick={handleOnCancel}
                type="button"
              >
                CANCEL
              </ButtonDefault>
            </div>
            <div className={cn(styles.buttonWrapper)}>
              <ButtonPrimary
                id="saveButton"
                disabled={isSaveDisabled}
                type="submit"
              >
                SAVE
              </ButtonPrimary>
            </div>
          </div>
        </Form>
      </div>
    </div>
  );
};
